import axios from 'axios'
import {
  Answer,
  SchemaType,
  SupplementalFormType,
} from '@verifiedit/form-generator'

export type PermitForm = {
  id: number
  type: string
  form: {
    template: {
      components: SchemaType[]
      supplementals?: SupplementalFormType[]
    }
  }
}

export type PermitFormSubmission = {
  createdAt: string
  formData: {
    $id: string
    $schema: string
    template: {
      schema: SchemaType[]
    }
  }[]
  id: number
  permitFormId: number
  visitLogId: number
  workOrderNumber: string
}

export async function fetchPermitForms(
  customerId: number,
  userTypeId: number,
): Promise<PermitForm[]> {
  const response = await axios.get(`api/customers/${customerId}/permits`, {
    params: {
      userTypeId: userTypeId,
    },
  })

  return response.data?.data
}

export async function submitPermitForm(
  contractorCompanyId: number | null,
  contractorCompanyName: string,
  customerId: number,
  siteId: number,
  permitFormId: number,
  formData: Map<string, Answer>,
  expectedEndPermitFormId: number | null = null,
): Promise<PermitFormSubmission> {
  const data = {
    contractorCompanyName: contractorCompanyName,
    customerId: customerId,
    formData: Object.fromEntries(formData),
    permitFormId: permitFormId,
    siteId: siteId,
  }

  if (contractorCompanyId) {
    data['contractorCompanyId'] = contractorCompanyId
  }

  if (expectedEndPermitFormId) {
    data['expectedEndPermitFormId'] = expectedEndPermitFormId
  }

  const response = await axios.post('api/permit-submissions', data)

  return response.data.data
}

export async function submitEndPermitForm(
  permitFormId: number,
  formData: Map<string, Answer>,
): Promise<PermitFormSubmission> {
  const response = await axios.post('api/end-permit-submissions', {
    formData: Object.fromEntries(formData),
    permitFormId: permitFormId,
  })

  return response.data.data
}
